const Icon: React.FC = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_364_68125)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.2882 9.376C19.7742 9.334 19.1139 9.33335 18.1667 9.33335H12.2501C11.7898 9.33335 11.4167 8.96026 11.4167 8.50002C11.4167 8.03978 11.7898 7.66669 12.2501 7.66669L18.2024 7.66669C19.1056 7.66668 19.834 7.66667 20.4239 7.71487C21.0313 7.76449 21.5648 7.86934 22.0584 8.12083C22.8424 8.5203 23.4798 9.15772 23.8793 9.94173C24.1308 10.4353 24.2356 10.9688 24.2852 11.5762C24.3334 12.1661 24.3334 12.8945 24.3334 13.7977V19.75C24.3334 20.2103 23.9603 20.5834 23.5001 20.5834C23.0398 20.5834 22.6667 20.2103 22.6667 19.75V13.8334C22.6667 12.8862 22.6661 12.2259 22.6241 11.7119C22.5829 11.2076 22.5061 10.9178 22.3943 10.6984C22.1546 10.228 21.7721 9.84552 21.3017 9.60584C21.0823 9.49402 20.7925 9.4172 20.2882 9.376Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.1346 10.5834H17.9489C18.3882 10.5833 18.7671 10.5833 19.0793 10.6088C19.4087 10.6357 19.7364 10.6952 20.0517 10.8558C20.5221 11.0955 20.9046 11.478 21.1443 11.9484C21.3049 12.2637 21.3644 12.5914 21.3913 12.9208C21.4168 13.233 21.4168 13.612 21.4167 14.0513V20.8655C21.4168 21.3048 21.4168 21.6837 21.3913 21.9959C21.3644 22.3253 21.3049 22.653 21.1443 22.9683C20.9046 23.4387 20.5221 23.8212 20.0517 24.0609C19.7364 24.2215 19.4087 24.281 19.0793 24.3079C18.7671 24.3334 18.3882 24.3334 17.9489 24.3334H11.1346C10.6953 24.3334 10.3164 24.3334 10.0042 24.3079C9.67477 24.281 9.34709 24.2215 9.03177 24.0609C8.56137 23.8212 8.17892 23.4387 7.93923 22.9683C7.77857 22.653 7.71914 22.3253 7.69222 21.9959C7.66672 21.6837 7.66673 21.3048 7.66675 20.8655V14.0512C7.66673 13.6119 7.66672 13.233 7.69222 12.9208C7.71914 12.5914 7.77857 12.2637 7.93923 11.9484C8.17892 11.478 8.56137 11.0955 9.03177 10.8558C9.34709 10.6952 9.67477 10.6357 10.0042 10.6088C10.3164 10.5833 10.6953 10.5833 11.1346 10.5834Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_364_68125"
          x="-2"
          y="-1"
          width="36"
          height="36"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_364_68125"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_364_68125"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default Icon
